module.exports = __webpack_public_path__ + "static/img/jjcSecond.0fbe8367.png";